// @ts-nocheck
import { Navigate } from "react-router-dom";

function Cover() {
  return <Navigate to="/sign-in" replace />;
}

export default Cover;
